import { useEffect, useState } from "react";
import TabGPT from "../../tabs/TabGPT";
import Tippy from "@tippyjs/react";
import TextField2 from "../../textfields/TextField2";
import TextField2T from "../../textfields/TextField2T";
import EquipmentTypeSelect from "../../modals/EquipmentTypeSelect";
import SearchBarDocuments from "../../textfields/SearchBarDocuments";
import PrimaryButton from "../../buttons/PrimaryButton";
import Icon1 from "../../icons/Icon";
import Collapsible from "../../layout/Collapsible";
import Modal1 from "../../modals/Modal1";
import Dropzone3 from "../../dropzones/DropZone3";
import { getOrRefreshFirebaseToken } from "../../config/getFirebaseToken";
import DropDownGPT03 from "../../dropdowns/DropDownGTP03";
import DropDownGPTS3 from "../../dropdowns/DropDownGPTS3";
import { useParams, useSearchParams } from "react-router-dom";
import {
  getArrayDocDataByID,
  getArrayDocDataByRef,
  getDocDataById,
  getFlutterTime,
  getLocalStringFromFlutter,
  getRefFromId,
  queryCollection,
} from "../../models/DataFunctions";
import { useSnackbar } from "notistack";
import { Spin } from "antd";
import updateDocDataFieldApi from "../../api/database/updateDocDataFieldApi";
import { useAppContext } from "../../config/AppContext";
import uploadDropZoneTemporary from "../../api/upload/uploadDropZoneTemporary";
import uploadFiles from "../../api/upload/uploadFiles";
import createDocApi from "../../api/database/createDocApi";
import getCarnetUrls from "../../api/presigned/getCarnetUrls";
import getFacadeUrl from "../../api/presigned/getFacadeUrl";
import addCarnetFacade from "../../api/addCarnetPhoto";
import PDFViewerGPT1 from "../../pdf/PDFViewerGPT1";
import MMName from "../../members/MMName";
import updateDocApi from "../../api/database/updateDocApi";
import { CarnetAM } from "../../actionmenus/CarnetAM";
import SecondaryButton from "../../buttons/SecondaryButton";
import SmallSpinner from "../../loading/SmallSpinner";
import addFileToDocument from "../../api/upload/addCarnetDocument";
import addCarnetDocument from "../../api/upload/addCarnetDocument";
import extractEquipmentFromXml from "../../api/equipment/extractEquipmentFromXml";
import extractEquipmentsFromXml from "../../api/equipment/extractEquipmentsFromXml";
import addEquipmentsToCarnet from "../../api/equipment/addEquipmentsToCarnet";
import removePieceFromCarnet from "../../api/equipment/removePieceFromCarnet";
import removeEquipmentFromCarnet from "../../api/equipment/removeEquipmentFromCarnet";
import SelectEquipmentModal from "../../modals/SelectEquipmentModal";
import EquipmentsCandidatesModal from "../../modals/EquipmentsCandidatesModal";
import { User } from "../../types/user";
import { Org } from "../../types/org";
import {
  Carnet,
  CarnetDocument,
  CarnetEquipment,
  File,
} from "../../types/types";
import { EquipmentModal } from "../../modals/EquipmentModal";
import addPartnerToCarnet from "../../api/partners/addPartnerToCarnet";
import deleteDocApi from "../../api/database/deleteDocApi";
import { DocumentReference } from "firebase/firestore";
import sendInvitationCarnetEmail from "../../api/send/sendInvitationCarnetEmail";
import { EQUIPMENT_CATEGORIES } from "./categorieMapping";
import fetchFacadeUrlFromHexagone from "../../api/fetchFacadeUrlFromHexagone";
import { isCarnetAdmin } from "./CarnetHelpers";
import refreshFileUrl from "../../api/upload/refreshFileUrl";
import { EquipementImage } from "./EquipementImage";

export function getReadableEquipmentInfo(source: any, type: any) {
  if (type === "generateur") {
    return {
      type: type,
      marque: source.marque_generateur || "-",
      modele: source.deno_comm_gene || "-",
      secondary: `P pleine charge: ${
        source.P_pleine_charge || "-"
      } • P auxi amont: ${source.P_auxi_amont || "-"}`,
    };
  } else if (type === "production_stockage") {
    return {
      marque: source.marque_ballon || "-",
      modele: source.deno_comm_ballon || "-",
      secondary: `Pmax: ${source.Pmax || "-"} • Type énergie base: ${
        source.type_energie_base || "-"
      }`,
    };
  }
  return { marque: "-", modele: "-", secondary: "" };
}

// Helper function to get all equipment types from EQUIPMENT_CATEGORIES
function getAllEquipmentTypes() {
  const equipmentTypes: {
    label: string;
    value: string;
    extra_label?: string;
    type?: string;
  }[] = [];

  // Create a structure to group by categories and subcategories
  Object.entries(EQUIPMENT_CATEGORIES.categories).forEach(
    ([categoryKey, category]: [string, any]) => {
      // Add category header (disabled item for visual separation)
      equipmentTypes.push({
        label: category.label,
        value: `category_${categoryKey}`,
        type: "header",
      });

      Object.entries(category.subcategories).forEach(
        ([subcategoryKey, subcategory]: [string, any]) => {
          // Sort equipment types alphabetically within each subcategory
          const sortedEquipmentTypes = [...subcategory.equipment_types].sort(
            (a, b) => a.label.localeCompare(b.label)
          );

          sortedEquipmentTypes.forEach((type: any) => {
            equipmentTypes.push({
              label: type.label,
              value: type.label,
              extra_label: subcategory.label,
            });
          });
        }
      );
    }
  );

  // Add separator and custom option
  equipmentTypes.push({
    label: "Personnalisé",
    value: "separator_custom",
    type: "header",
  });

  equipmentTypes.push({
    label: "Autre (saisir manuellement)",
    value: "custom",
  });

  return equipmentTypes;
}

interface CarnetProps {
  userData: User; // Replace 'any' with a more specific type if available
  orgData: Org; // Replace 'any' with a more specific type if available
  navigateWorkspace: (path: string) => void;
}

export const CarnetPage = ({
  userData,
  orgData,
  navigateWorkspace,
}: CarnetProps) => {
  const { id } = useParams(); // Access the `id` parameter from the URL

  const [tabs, setTabs] = useState<any>([]);
  const [drop_open, setDropOpen] = useState(false);
  const [documents, setDocuments] = useState<CarnetDocument[]>([]);
  const [partners, setPartners] = useState<Org[]>([]);
  const [xmlModalOpen, setXmlModalOpen] = useState<boolean>(false);
  const [extractedCandidates, setExtractedCandidates] = useState([]);
  const [xmlFiles, setXmlFiles] = useState<File[]>([]);
  const [loadingXml, setLoadingXml] = useState<boolean>(false);
  const [loadingPartners, setLoadingPartners] = useState<boolean>(false);
  const [partner_value, setPartnerValue] = useState(null);
  const [partner_options, setPartnerOptions] = useState<
    { label: string; value: string }[]
  >([]);
  const [manualToolOpen, setManualToolOpen] = useState<boolean>(false);
  const [manualToolType, setManualToolType] = useState(null);
  const [manualToolBrand, setManualToolBrand] = useState<string>("");
  const [manualToolModel, setManualToolModel] = useState<string>("");
  const [manualToolConsumption, setManualToolConsumption] =
    useState<string>("");
  const [manualToolLabel, setManualToolLabel] = useState<string>("");
  const [selectedPiece, setSelectedPiece] = useState<string>("");
  const [newPieceName, setNewPieceName] = useState<string>("");
  const [addingPiece, setAddingPiece] = useState<boolean>(false);
  const [pieceOptions, setPieceOptions] = useState<any[]>([]);
  const [equipmentModalOpen, setEquipmentModalOpen] = useState<boolean>(false);
  const [selectedEquipment, setSelectedEquipment] =
    useState<CarnetEquipment | null>(null);
  const [equipmentDropdownOpen, setEquipmentDropdownOpen] =
    useState<boolean>(false);
  const [xmlExtractModalOpen, setXmlExtractModalOpen] =
    useState<boolean>(false);
  const [extractedEquipments, setExtractedEquipments] = useState<any[]>([]);
  const [loadingXmlExtract, setLoadingXmlExtract] = useState<boolean>(false);
  const [facadeUrl, setFacadeUrl] = useState<string | null>(null);
  const [loadingFacadeUpload, setLoadingFacadeUpload] =
    useState<boolean>(false);
  const [bookshelfImportModalOpen, setBookshelfImportModalOpen] =
    useState<boolean>(false);
  const [bookshelfEquipments, setBookshelfEquipments] = useState<any[]>([]);
  const [loadingBookshelfEquipments, setLoadingBookshelfEquipments] =
    useState<boolean>(false);

  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (
    message: string,
    variant: "success" | "error" | "default" | "warning" | "info" | undefined
  ) => {
    enqueueSnackbar(message, { variant });
  };
  const [equipments, setEquipments] = useState<CarnetEquipment[]>([]);
  const [carnetData, setCarnetData] = useState<Carnet | null>(null);

  const handleXmlDrop = async (files: File[]) => {
    setXmlFiles(files);
  };

  const handleExtractXml = async () => {
    if (!xmlFiles.length) return;
    setLoadingXml(true);
    try {
      const token = await getOrRefreshFirebaseToken();
      const res = await extractEquipmentFromXml(xmlFiles[0], prefix);
      // in each element of the res.extracted, use the getReadableEquipmentInfo function to get the readable info
      res.extracted = res.extracted.map((generation: any) => {
        return {
          ...generation,
          generateurs: generation.generateurs.map((gen: any) => ({
            ...gen,
            source: getReadableEquipmentInfo(gen.source, "generateur"),
          })),
          production_stockage: generation.production_stockage.map(
            (prod: any) => ({
              ...prod,
              source: getReadableEquipmentInfo(
                prod.source,
                "production_stockage"
              ),
            })
          ),
        };
      });
      setExtractedCandidates(res.extracted);
    } catch (e) {
      handleClickVariant("Erreur lors de l'extraction XML", "error");
    } finally {
      setLoadingXml(false);
    }
  };

  const handleRemovePiece = async (piece: any) => {
    if (!piece || !carnetData) return;
    try {
      await removePieceFromCarnet(carnetData.id, piece, prefix);
      handleClickVariant("Pièce supprimée", "success");
      setPieceOptions(pieceOptions.filter((p) => p.value !== piece));
      setSelectedPiece("");
    } catch (e) {
      handleClickVariant("Erreur lors de la suppression de la pièce", "error");
    }
  };

  const handleRemoveEquipment = async (equipment: string) => {
    if (!equipment || !carnetData) return;
    try {
      await removeEquipmentFromCarnet(carnetData.id, equipment, prefix);
      handleClickVariant("Équipement supprimé", "success");
      setEquipments(equipments.filter((e) => e.id !== equipment));
    } catch (e) {
      handleClickVariant(
        "Erreur lors de la suppression de l'équipement",
        "error"
      );
    }
  };

  const handleAddCandidate = async (candidate: any) => {
    if (!carnetData) return;
    const token = await getOrRefreshFirebaseToken();
    let candidates = [candidate];
    await addEquipmentsToCarnet(candidates, carnetData.id, prefix);
    handleClickVariant("Équipement ajouté", "success");
    handleFetchData();
  };

  const handleExtractFromXml = async () => {
    if (!carnetData) return;
    setLoadingXmlExtract(true);
    try {
      const response = await extractEquipmentsFromXml(carnetData.id, prefix);
      setExtractedEquipments(response.equipments || []);
      setXmlExtractModalOpen(true);
      setEquipmentDropdownOpen(false);
    } catch (e) {
      handleClickVariant(
        "Erreur lors de l'extraction des équipements",
        "error"
      );
      console.error("Error extracting equipments:", e);
    } finally {
      setLoadingXmlExtract(false);
    }
  };

  const handleAddSelectedEquipments = async (
    selectedEquipments: Array<{
      equipment: any;
      selectionData: {
        piece: string;
        equipment_type: string;
        customPieceName?: string;
      };
    }>
  ) => {
    if (!carnetData || selectedEquipments.length === 0) return;

    const equipmentsToAdd = selectedEquipments.map(
      ({ equipment, selectionData }) => {
        const finalPiece =
          selectionData.piece === "custom"
            ? selectionData.customPieceName || ""
            : selectionData.piece || "";

        const finalEquipmentType = selectionData.equipment_type || "";

        return {
          ...equipment,
          piece: finalPiece,
          equipment_type: finalEquipmentType,
          manual_entry: false,
        };
      }
    );

    try {
      await addEquipmentsToCarnet(equipmentsToAdd, carnetData.id, prefix, true);
      handleClickVariant(
        `${equipmentsToAdd.length} équipement(s) ajouté(s)`,
        "success"
      );
      setExtractedEquipments([]);
      handleFetchData();
    } catch (e) {
      handleClickVariant("Erreur lors de l'ajout des équipements", "error");
      console.error("Error adding equipments:", e);
    }
  };

  const fetchBookshelfEquipments = async () => {
    if (!orgData?.id) return;

    setLoadingBookshelfEquipments(true);
    try {
      const filters = [
        { field: "org_id", operator: "==", value: orgData.id },
        { field: "type", operator: "==", value: "bookshelf_equipment" },
      ];

      const equipment = await queryCollection("logement_bookshelf", filters);
      setBookshelfEquipments(equipment || []);
    } catch (error) {
      console.error("Error fetching bookshelf equipment:", error);
      handleClickVariant("Erreur lors du chargement des équipements", "error");
      setBookshelfEquipments([]);
    } finally {
      setLoadingBookshelfEquipments(false);
    }
  };

  const handleOpenBookshelfImport = async () => {
    setBookshelfImportModalOpen(true);
    await fetchBookshelfEquipments();
  };

  const handleAddBookshelfEquipments = async (
    selectedEquipments: Array<{
      equipment: any;
      selectionData: {
        piece: string;
        equipment_type: string;
        customPieceName?: string;
      };
    }>
  ) => {
    if (!carnetData || selectedEquipments.length === 0) return;

    const equipmentsToAdd = selectedEquipments.map(
      ({ equipment, selectionData }) => {
        const finalPiece =
          selectionData.piece === "custom"
            ? selectionData.customPieceName || ""
            : selectionData.piece || "";

        const finalEquipmentType = selectionData.equipment_type || "";

        return {
          name: equipment.name,
          brand: equipment.brand,
          model: equipment.model,
          num_serie: equipment.num_serie,
          notes: equipment.notes,
          lifespan: equipment.lifespan,
          piece: finalPiece,
          equipment_type: finalEquipmentType,
          manual_entry: false,
          files: equipment.files || [],
          maintenance_tasks: equipment.maintenance_tasks || [],
        };
      }
    );

    try {
      await addEquipmentsToCarnet(
        equipmentsToAdd,
        carnetData.id,
        prefix,
        false,
        true
      );
      handleClickVariant(
        `${equipmentsToAdd.length} équipement(s) importé(s) depuis la bibliothèque`,
        "success"
      );
      setBookshelfEquipments([]);
      handleFetchData();
    } catch (e) {
      handleClickVariant(
        "Erreur lors de l'importation des équipements",
        "error"
      );
      console.error("Error importing equipments from bookshelf:", e);
    }
  };

  const handleFacadeUpload = async (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const file = event.target.files?.[0];
    if (!file || !carnetData) return;

    if (!file.type.startsWith("image/")) {
      handleClickVariant("Veuillez sélectionner un fichier image", "error");
      return;
    }

    setLoadingFacadeUpload(true);
    try {
      const result = await addCarnetFacade(carnetData.id, file, prefix);
      if (result.success) {
        setFacadeUrl(result.url);
        // const photoFile: File = {
        //   id: result.file_id || `facade_${carnetData.id}`,
        //   name: file.name,
        //   url: result.url,
        //   octets: file.size
        // };
        // await updateDocDataFieldApi(carnetData.ref, "photo", photoFile, prefix);
        // setCarnetData({ ...carnetData, photo: photoFile });
        handleClickVariant("Photo de façadee ajoutée", "success");
      }
    } catch (error) {
      console.error("Error uploading facade photo:", error);
      handleClickVariant("Erreur lors de l'ajout de la photo", "error");
    } finally {
      setLoadingFacadeUpload(false);
    }
  };

  const handleFetchData = async () => {
    if (!userData || !orgData) {
      console.warn("userData or orgData not available");
      return;
    }
    //await getCarnetUrls(id, prefix);
    const partners = (await queryCollection("org", [
      {
        field: "masters_id",
        operator: "array-contains",
        value: userData.org_id,
      },
    ])) as Org[];
    setAllPartners(partners);
    setPartnerOptions(
      partners.map((p) => ({
        label: p.name,
        value: p.id,
      }))
    );
    //  const token = await getOrRefreshFirebaseToken();
    // await getCarnetUrls(id, prefix);

    const carnet = (await getDocDataById("carnet", id)) as any as Carnet;
    if (carnet) {
      let documents = await getArrayDocDataByID(
        "carnet_document",
        carnet.documents_id || []
      );
      let equipments = await getArrayDocDataByID(
        "carnet_equipment",
        carnet.equipments_id || []
      );
      setCarnetData(carnet);
      setDocuments(documents);
      setEquipments(equipments);
      // Extract partner IDs from visions array
      const partnerIds = (carnet.visions || []).map((v: any) => v.org_id);
      setPartners(partners.filter((p) => partnerIds.includes(p.id)));
      setPieceOptions(
        carnet.pieces?.map((p) => ({ label: p, value: p })) || []
      );

      // Fetch facade URL if carnet has a photo
      if (carnet.photo) {
        try {
          const facadeResponse = await getFacadeUrl(carnet.id, prefix);
          if (facadeResponse.success) {
            setFacadeUrl(facadeResponse.url);
          }
        } catch (e) {
          console.error("Error fetching facade URL:", e);
        }
      } else {
        if (carnet.folder_id != null) {
          try {
            let res = await fetchFacadeUrlFromHexagone(carnet.id, prefix);
            setFacadeUrl(res.url);
          } catch (e) {
            console.error("Error fetching facade URL from folder_id:", e);
          }
        }
      }

      const tabs = [
        {
          id: "documents",
          label: "Documents",
        },
        {
          id: "tools",
          label: "Equipements",
        },
      ];

      // Add partners tab only for admins
      if (isCarnetAdmin(orgData, carnet)) {
        tabs.unshift({
          id: "partners",
          label: "Partenaires",
        });
      }

      setTabs(tabs);
    } else {
      handleClickVariant("Carnet introuvable", "error");
      navigateWorkspace("/carnets");
    }
  };

  useEffect(() => {
    if (orgData && userData) {
      handleFetchData();
    }
  }, [orgData, userData]); // Fetch data when userData or orgData changes
  const { appState, setAppState, filter } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;
  const [loadingDrop, setLoadingDrop] = useState<boolean>(false);
  const [all_partners, setAllPartners] = useState<Org[]>([]);
  const [dropped_files, setDroppedFiles] = useState<File[]>([]);
  const [input_value, setInputValue] = useState<string>("");
  const [selected_dropped_files, setSelectedDroppedFiles] = useState<File[]>(
    []
  );
  const [dropped_exists, setDroppedExists] = useState<boolean>(false);
  const [tool_open, setToolOpen] = useState<boolean>(false);
  const [tool_value, setToolValue] = useState(null);
  const [fetchedTools, setFetchedTools] = useState([
    {
      value: "chaudiere",
      label: "Chaudière",
    },
  ]);
  const [activation_open, setActivationOpen] = useState(false);
  const [loadingTransfer, setLoadingTransfer] = useState(false);

  const [pdfOpen, setPdfOpen] = useState<boolean>(false);
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const onDelete = (file: any) => {
    const new_files = dropped_files.filter((f) => f !== file);
    setDroppedFiles(new_files);
    if (new_files.length === 0) {
      setDroppedExists(false);
    }
  };

  const handleAddNewPiece = async (pieceName: string) => {
    if (!carnetData) return;
    setAddingPiece(true);
    try {
      await updateDocApi(
        "carnet",
        carnetData.id,
        {
          pieces: [...(carnetData.pieces || []), pieceName],
        },
        prefix
      );
      handleClickVariant("Pièce ajoutée", "success");
      setPieceOptions([
        ...pieceOptions,
        { label: pieceName, value: pieceName },
      ]);
      setNewPieceName("");
    } catch (e) {
      handleClickVariant("Erreur lors de l'ajout de la pièce", "error");
    } finally {
      setAddingPiece(false);
    }
  };

  const handlenewPartner = async (partner: any) => {
    if (!partner || !carnetData) return;
    if (!partner) {
      handleClickVariant("Veuillez choisir un partenaire", "error");
      return;
    }
    let visions = carnetData.visions || [];
    // Check if partner already exists in visions
    if (visions.some((v: any) => v.org_id === partner.value)) {
      handleClickVariant("Partenaire déjà ajouté", "error");
      return;
    }
    setLoadingPartners(true);
    await addPartnerToCarnet(carnetData.id, partner.value, prefix);
    handleClickVariant("Partenaire ajouté", "success");
    setPartnerValue(null);
    await handleFetchData();
    setLoadingPartners(false);
  };

  const [loadingEmail, setLoadingEmail] = useState(false);

  const handleSendInvitation = async () => {
    setLoadingEmail(true);
    const token = await getOrRefreshFirebaseToken();
    if (!carnetData?.email?.replace(/ /g, "")) {
      handleClickVariant("Le carnet n'a pas d'email renseigné", "error");
      setLoadingEmail(false);
      setActivationOpen(false);
      return;
    }
    let res = await sendInvitationCarnetEmail(carnetData!.id, token, prefix);
    if (res.success) {
      await updateDocDataFieldApi(carnetData!.ref, "state", "sent", prefix);
      handleClickVariant("Invitation envoyée par email", "success");
    } else {
      handleClickVariant("Erreur lors de l'envoi de l'invitation", "error");
    }
    setActivationOpen(false);
    setResendInvitation(false);
    setLoadingEmail(false);
  };
  const onDeletePartner = async (partner: any) => {
    if (!partner || !carnetData) return;
    setLoadingPartners(true);
    console.log("delete partner", partner);
    let visions = carnetData.visions || [];
    visions = visions.filter((v: any) => v.org_id !== partner.id);
    let partners_id = carnetData.partners_id || [];
    partners_id = partners_id.filter((id: string) => id !== partner.id);
    await updateDocApi(
      "carnet",
      carnetData.id,
      {
        visions: visions,
        partners_id: partners_id,
      },
      prefix
    );
    handleClickVariant("Partenaire supprimé", "success");
    await handleFetchData();
    setLoadingPartners(false);
  };

  const handleAddDocuments = async () => {
    if (dropped_files.length === 0) {
      handleClickVariant("Veuillez ajouter des documents", "error");
      return;
    }
    if (!carnetData) {
      handleClickVariant("Carnet introuvable", "error");
      return;
    }
    setLoadingTransfer(true);

    const token = await getOrRefreshFirebaseToken();

    for (let i = 0; i < selected_dropped_files.length; i++) {
      try {
        // Use addFileToDocument for each file
        let file = selected_dropped_files[i];
        await addCarnetDocument(
          file,
          carnetData.id,
          document_type,
          token,
          prefix
        );
      } catch (e) {
        console.error("Erreur lors de l'ajout du document :", e);
      }
    }

    handleClickVariant("Documents ajoutés", "success");
    setDroppedFiles([]);
    setSelectedDroppedFiles([]);
    setDroppedExists(false);
    setDropOpen(false);
    await handleFetchData();
    setLoadingTransfer(false);
  };

  const handleChangeInfoCell = async (field: any, value: any) => {
    if (value === null) return;
    if (!carnetData) return;
    setCarnetData({ ...carnetData, [field]: value } as Carnet);
  };
  const [ask_sending_email, setAskSendingEmail] = useState(false);
  const [loadingActivate, setLoadingActivate] = useState(false);
  const [resend_invitation, setResendInvitation] = useState(false);
  const handleActivateCarnet = async () => {
    if (!carnetData) return;
    setLoadingActivate(true);
    let credits = orgData?.logement?.facturation?.credits || 0;
    if (credits <= 0) {
      handleClickVariant("Crédits insuffisants", "error");
      setLoadingActivate(false);
      return;
    }
    await updateDocDataFieldApi(carnetData.ref, "activated", true, prefix);
    await updateDocDataFieldApi(
      orgData.ref,
      "logement.facturation.credits",
      Math.max((orgData?.logement?.facturation?.credits || 0) - 1, 0),
      prefix
    );
    handleClickVariant("Carnet activé", "success");
    setAskSendingEmail(true);
    handleFetchData();
    setLoadingActivate(false);
  };

  const handleSyncInfoCell = async (field: any, value: any) => {
    if (!carnetData) return;

    if (!value) return;

    if (field === "email") {
      if (carnetData.activated && value !== carnetData.email) {
        setResendInvitation(true);
      }
    }

    await updateDocDataFieldApi(carnetData.ref, field, value, prefix);

    handleClickVariant("Champ mis à jour", "success");
    handleFetchData();
  };
  const onDropZone = async (files: any) => {
    setLoadingDrop(true);
    const token = await getOrRefreshFirebaseToken();

    let new_files = [];

    new_files = files.filter(
      (file: any) =>
        !dropped_files.map((filed) => filed.name).includes(file.name)
    );

    let new_drop_files: any[] = [];

    for (let i = 0; i < new_files.length; i++) {
      let res = (await uploadDropZoneTemporary(
        new_files[i],
        new_files[i].name,
        prefix
      )) as any;
      let url = res.url;
      let name = res.name;
      new_drop_files = [...new_drop_files, { url: url, name: name }];
    }
    let new_dropped_files = [...dropped_files, ...new_drop_files];
    setDroppedFiles(new_dropped_files);
    setSelectedDroppedFiles(new_dropped_files);

    setDroppedExists(true);

    setLoadingDrop(false);
  };
  const [activetab, setActiveTab] = useState("documents");
  const handleTabChange = (tab: any) => {
    setActiveTab(tab);
  };

  const handleLoadPdf = async (doc: CarnetDocument) => {
    // load urls first
    const token = await getOrRefreshFirebaseToken();
    if (!doc.file) {
      handleClickVariant("Document introuvable", "error");
      return;
    }
    let new_url = await refreshFileUrl(doc.file!.id, token, prefix);
    // await getCarnetUrls(id, prefix);
    // let docs: CarnetDocument[] = await getArrayDocDataByID(
    //   "carnet_document",
    //   carnetData?.documents_id || []
    // );
    // if (!docs) return;
    // let matchingDoc = docs.find((d: CarnetDocument) => d.id === doc.id);
    // if (!matchingDoc || !matchingDoc.file) {
    //   handleClickVariant("Document introuvable", "error");
    //   return;
    // }
    let fresh_doc = {
      ...doc,
      file: {
        ...doc.file,
        url: new_url,
      },
    };

    const url = new URL(new_url);
    const pathname = url.pathname.toLowerCase();
    if (pathname.endsWith(".pdf")) {
      setSelectedFile(fresh_doc?.file || null);
      setPdfOpen(true);
    } else {
      window.open(fresh_doc.file.url, "_blank");
    }
  };

  const handleDelete = async () => {
    // find the opened pdf document in the documents array
    // and delete it
    if (!selectedFile || !carnetData) return;
    const documentToDelete = documents.find(
      (doc) => doc.file?.id === selectedFile.id
    );
    if (!documentToDelete) {
      console.error("Document not found for deletion", documents);
      handleClickVariant("Document introuvable", "error");
      return;
    }
    try {
      await deleteDocApi(
        getRefFromId("carnet_document", documentToDelete.id),

        prefix
      );
      await updateDocDataFieldApi(
        carnetData.ref,
        "documents_id",
        (carnetData.documents_id || []).filter(
          (doc_id: string) => doc_id !== documentToDelete.id
        ),
        prefix
      );
      handleClickVariant("Document supprimé", "success");
      setPdfOpen(false);
      setSelectedFile(null);
      // Refresh documents
      await handleFetchData();
    } catch (e) {
      console.error("Erreur lors de la suppression du document :", e);
      handleClickVariant("Erreur lors de la suppression du document", "error");
    }
  };

  const handleDeleteDocument = async (doc: CarnetDocument) => {
    if (!carnetData) return;
    try {
      await deleteDocApi(getRefFromId("carnet_document", doc.id), prefix);
      await updateDocDataFieldApi(
        carnetData.ref,
        "documents_id",
        (carnetData.documents_id || []).filter(
          (doc_id: string) => doc_id !== doc.id
        ),
        prefix
      );
      handleClickVariant("Document supprimé", "success");
      // Refresh documents
      await handleFetchData();
    } catch (e) {
      console.error("Erreur lors de la suppression du document :", e);
      handleClickVariant("Erreur lors de la suppression du document", "error");
    }
  };

  const [document_type, setDocumentType] = useState<string>("contrat");

  if (!carnetData) {
    return (
      <div className="flex flex-col h-full overflow-y-auto pl-4  ">
        <SmallSpinner />
      </div>
    );
  }

  return (
    <div className="flex flex-col h-full overflow-y-auto pl-4 mr-4  ">
      <Modal1 isOpen={pdfOpen} onClose={() => setPdfOpen(false)}>
        <div className="bg-white rounded-xl w-full max-w-[90vw] overflow-auto h-full max-h-[80vh] gap-2 flex flex-col ">
          <PDFViewerGPT1
            handleDelete={handleDelete}
            handleClose={() => setPdfOpen(false)}
            pdfUrl={selectedFile?.url || ""}
          ></PDFViewerGPT1>
        </div>
      </Modal1>
      <Modal1 isOpen={activation_open} onClose={() => setActivationOpen(false)}>
        <div className="flex flex-col  h-fit w-c400 bg-white rounded-xl shadow-xl overflow-auto ">
          <div className="flex flex-row justify-between items-center gap-2  p-4 border-b-1">
            <div className="font-medium text-h2 ">Activation du carnet</div>
          </div>
          {ask_sending_email ? (
            <>
              <div className="flex flex-col p-4 gap-2">
                <div
                  className={`text-black  bg-white 
             rounded-xl   w-full  flex flex-col gap-1 `}
                >
                  <div className=" text-h3 flex flex-row   ">
                    Le carnet a été activé.
                  </div>
                  <div className=" text-h3 flex flex-row   ">
                    Envoyez maintenant un email au particulier pour qu'il puisse
                    accéder à son carnet d'information du logement.
                  </div>
                </div>
              </div>
              <div className="text-sm text-gray-500  p-4 border-t-1">
                <div className="flex flex-row gap-2 justify-end   ">
                  <SecondaryButton
                    onClick={() => {
                      setActivationOpen(false);
                    }}
                  >
                    Ignorer
                  </SecondaryButton>
                  <PrimaryButton onClick={handleSendInvitation}>
                    Envoyer au particulier{" "}
                    {loadingEmail && <SmallSpinner></SmallSpinner>}
                  </PrimaryButton>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="flex flex-col p-4 gap-2">
                {(orgData?.logement?.facturation?.credits || 0) - 1 >= 0 && (
                  <div
                    className={`text-black  bg-white 
             rounded-xl   w-full  flex flex-col gap-1 `}
                  >
                    <div className="flex flex-row justify-between">
                      <div className=" text-h3 flex flex-row   ">
                        Crédits restants
                      </div>
                      <div className=" text-h3 flex flex-row  bg-neutral-100 px-2 py-0.5 rounded-md text-neutral-700  ">
                        {orgData?.logement?.facturation?.credits || 0}
                      </div>
                    </div>{" "}
                    <div className="flex flex-row justify-between">
                      <div className=" text-h3 flex flex-row   ">Opération</div>
                      <div className=" text-h3 flex flex-row  bg-blue-100 px-2 py-0.5 rounded-md text-blue-700 ">
                        -1
                      </div>
                    </div>{" "}
                    <div className="flex flex-row justify-between">
                      <div className=" text-h3 flex flex-row   ">
                        Crédits futurs
                      </div>
                      <div className=" text-h3 flex flex-row bg-neutral-100 px-2 py-0.5 rounded-md text-neutral-700  ">
                        {(orgData?.logement?.facturation?.credits || 0) - 1 >= 0
                          ? (orgData?.logement?.facturation?.credits || 0) - 1
                          : 0}
                      </div>
                    </div>
                  </div>
                )}{" "}
                {(orgData?.logement?.facturation?.credits || 0) - 1 < 0 && (
                  <div
                    className={`text-black  mt-4 bg-white   bg-gradient-to-r from-indigo-50 to-transparent
             rounded-xl cursor-pointer  w-full  p-4 flex flex-col border-1    border-indigo-100`}
                  >
                    <div className="flex flex-row justify-between">
                      <div className=" text-h3 flex flex-row   ">
                        Crédits insuffisants
                      </div>
                    </div>
                  </div>
                )}
              </div>
              <div className="text-sm text-gray-500  p-4 border-t-1">
                <div className="flex flex-row gap-2 justify-end   ">
                  <PrimaryButton
                    onClick={handleActivateCarnet}
                    disabled={
                      (orgData?.logement?.facturation?.credits || 0) - 1 < 0
                    }
                  >
                    Confirmer {loadingActivate && <SmallSpinner></SmallSpinner>}
                  </PrimaryButton>
                </div>
              </div>{" "}
            </>
          )}
        </div>
      </Modal1>
      <Modal1
        isOpen={resend_invitation}
        onClose={() => setResendInvitation(false)}
      >
        <div className="flex flex-col  h-fit w-c400 bg-white rounded-xl shadow-xl overflow-auto ">
          <div className="flex flex-row justify-between items-center gap-2  p-4 border-b-1">
            <div className="font-medium text-h2 ">
              Modification des coordonnées
            </div>
          </div>

          <div className="flex flex-col p-4 gap-2">
            <div
              className={`text-black  bg-white 
             rounded-xl   w-full  flex flex-col gap-1 `}
            >
              <div className=" text-h3 flex flex-row   ">
                Le carnet a été modifié.
              </div>
              <div className=" text-h3 flex flex-row   ">
                Nous vous invitons à renvoyer un email d'invitation afin que le
                nouveau particulier puisse accéder à son carnet.
              </div>
            </div>
          </div>
          <div className="text-sm text-gray-500  p-4 border-t-1">
            <div className="flex flex-row gap-2 justify-end   ">
              <SecondaryButton
                onClick={() => {
                  setResendInvitation(false);
                }}
              >
                Ignorer
              </SecondaryButton>
              <PrimaryButton onClick={handleSendInvitation}>
                Envoyer au particulier{" "}
                {loadingEmail && <SmallSpinner></SmallSpinner>}
              </PrimaryButton>
            </div>
          </div>
        </div>
      </Modal1>
      <Modal1 isOpen={drop_open} onClose={() => setDropOpen(false)}>
        <div className="bg-white rounded-xl w-c600 h-fit gap-2 flex flex-col p-4">
          <div className="text-h1 mb-4 font-medium text-black">
            Ajouter des documents
          </div>
          <Dropzone3
            onDrop={onDropZone}
            files={dropped_files}
            selected_files={selected_dropped_files}
            loading={loadingDrop}
            setSelectedDroppedFiles={setDroppedFiles}
            handleClickVariant={handleClickVariant}
            onDelete={onDelete}
          ></Dropzone3>
          <DropDownGPT03
            items={[
              { label: "Contrat d’assurance", value: "contrat" },
              { label: "Contrat d’entretien", value: "entretien" },
              { label: "Ouvrage exécuté", value: "ouvrage" },
              { label: "Mes diagnostics", value: "diagnostic" },
              { label: "Photos", value: "photos" },
              { label: "Factures", value: "factures" },
              { label: "Plans", value: "plans" },
              { label: "Xml", value: "xml" },
            ]}
            value={document_type}
            onChange={(e) => setDocumentType(e.value as string)}
            label="Type de document"
          ></DropDownGPT03>
          <PrimaryButton
            onClick={handleAddDocuments}
            className={"ml-auto mt-4"}
          >
            Enregistrer les documents{" "}
            <SmallSpinner loading={loadingTransfer} margin={4}></SmallSpinner>
          </PrimaryButton>
        </div>
      </Modal1>
      <Modal1 isOpen={tool_open} onClose={() => setToolOpen(false)}>
        <SelectEquipmentModal
          onClose={() => setToolOpen(false)}
          carnetId={carnetData.id}
          onEquipmentSelected={setSelectedEquipment}
          pieceOptions={pieceOptions}
          userData={userData}
          prefix={prefix}
          onRefresh={handleFetchData}
          handleAddNewPiece={handleAddNewPiece}
        ></SelectEquipmentModal>
      </Modal1>
      {/* Modal for XML extraction */}
      <Modal1 isOpen={xmlModalOpen} onClose={() => setXmlModalOpen(false)}>
        <div className="bg-white rounded-xl w-c800 h-fit gap-2 flex flex-col p-4">
          <div className="text-h1 mb-4 font-medium text-black">
            Extraction depuis XML
          </div>
          <Dropzone3
            onDrop={(files: any) => handleXmlDrop(files)}
            files={xmlFiles}
            selected_files={xmlFiles}
            loading={loadingXml}
            setSelectedDroppedFiles={(files: any) => setXmlFiles(files)}
            onDelete={() => setXmlFiles([])}
            handleClickVariant={handleClickVariant}
          ></Dropzone3>
          <PrimaryButton onClick={handleExtractXml} className="mt-4 ml-auto">
            Extraire les équipements
            <SmallSpinner loading={loadingXml}></SmallSpinner>
          </PrimaryButton>
          {extractedCandidates.map((generation: any, i) => (
            <div key={i} className="mt-6">
              <div className="text-h2 font-semibold text-black mb-2">
                Équipements pour la génération : {generation.generation}
              </div>

              {generation.generateurs.length === 0 &&
                generation.production_stockage.length === 0 && (
                  <div className="text-sm italic text-gray-500 mt-1">
                    Aucune donnée disponible pour cette génération.
                  </div>
                )}

              {["generateurs", "production_stockage"].map((type) =>
                generation[type]?.map((block: any, idx: number) => (
                  <div
                    key={idx}
                    className="bg-shadow_4 p-4 rounded-xl mb-4 border-1 border-slate-200"
                  >
                    <div className="text-h3 font-medium text-indigo-700">
                      {type === "generateurs"
                        ? "Générateur"
                        : "Production/Stockage"}
                    </div>
                    <div className="text-black text-h4 mt-2">
                      Marque : {block.source.marque} — Modèle :{" "}
                      {block.source.modele}
                    </div>

                    {block.matches.length === 0 && (
                      <div className="text-sm italic text-gray-500 mt-2">
                        Aucun équipement correspondant trouvé.
                      </div>
                    )}

                    <div className="grid grid-cols-1 md:grid-cols-2 gap-2 mt-4">
                      {block.matches.map((match: any, j: number) => (
                        <div
                          key={j}
                          className="bg-white border-1 border-gray-200 p-3 rounded-md shadow-md flex flex-col gap-1"
                        >
                          <div className="text-h4 font-semibold">
                            {match.model} ({match.brand})
                          </div>
                          <div className="text-sm text-gray-500">
                            {match.product_group} • Label énergie :{" "}
                            {match.label || "-"}
                          </div>
                          <PrimaryButton
                            className="w-fit mt-2"
                            onClick={() => handleAddCandidate(match)}
                          >
                            Ajouter au carnet
                          </PrimaryButton>
                        </div>
                      ))}
                    </div>
                  </div>
                ))
              )}
            </div>
          ))}
        </div>
      </Modal1>

      {/* Modal for Equipment Candidates */}
      <EquipmentsCandidatesModal
        isOpen={xmlExtractModalOpen}
        onClose={() => setXmlExtractModalOpen(false)}
        title="Équipements extraits du XML"
        equipments={extractedEquipments}
        pieceOptions={pieceOptions}
        onAddEquipments={handleAddSelectedEquipments}
        emptyMessage="Aucun équipement trouvé dans les fichiers XML"
        addButtonText="Ajouter les équipements sélectionnés"
      />

      {/* Modal for Bookshelf Import */}
      <EquipmentsCandidatesModal
        isOpen={bookshelfImportModalOpen}
        onClose={() => setBookshelfImportModalOpen(false)}
        title="Importer des équipements de la bibliothèque"
        equipments={bookshelfEquipments}
        pieceOptions={pieceOptions}
        onAddEquipments={handleAddBookshelfEquipments}
        emptyMessage="Aucun équipement trouvé dans la bibliothèque"
        addButtonText="Importer les équipements sélectionnés"
        showSearch={true}
        orgData={orgData}
        isBookshelfMode={true}
      />

      <div className="flex flex-row gap-10">
        <div className="flex flex-col w-full max-w-c1k">
          <div
            onClick={() => navigateWorkspace("/carnets")}
            className="text-h2 text-primary font-medium cursor-pointer  "
          >
            Carnets
          </div>{" "}
          <div className="flex flex-row gap-2 items-center justify-between">
            <div className="flex flex-row gap-2 items-center">
              <div className="text-hx text-black font-medium mt-3 ">
                {carnetData.name}
              </div>
              {carnetData.state === "received" ? (
                <div className="inline-flex h-6 items-center rounded-full px-3 py-1 bg-green-100 text-green-700 text-sm whitespace-nowrap mt-3">
                  Reçu par le particulier
                </div>
              ) : carnetData.state === "sent" ? (
                <div className="inline-flex h-6 items-center rounded-full px-3 py-1 bg-purple-100 text-purple-700 text-sm whitespace-nowrap mt-3">
                  Envoyé au particulier
                </div>
              ) : null}
            </div>
            <CarnetAM
              carnetData={carnetData}
              prefix={prefix}
              handleClickVariant={handleClickVariant}
              navigateWorkspace={navigateWorkspace}
              orgData={orgData}
              setActivationOpen={setActivationOpen}
            ></CarnetAM>
          </div>
          <div className="mt-3 relative">
            {facadeUrl ? (
              <div className="w-c200 h-20 rounded-2xl object-cover flex flex-col justify-center items-center bg-neutral-200 relative">
                <img
                  src={facadeUrl}
                  className="w-full h-full rounded-2xl object-cover"
                />
                {/* Pen icon in top right corner */}
                <div className="absolute top-2 right-2 w-6 h-6 bg-black hover:bg-gray-700 rounded-full shadow-lg transition-all duration-200 cursor-pointer z-10 flex items-center justify-center hover:scale-110">
                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleFacadeUpload}
                    className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                    disabled={loadingFacadeUpload}
                  />
                  {loadingFacadeUpload ? (
                    <SmallSpinner />
                  ) : (
                    <Icon1 icon_name="modify" fill="white" size={15} />
                  )}
                </div>
              </div>
            ) : (
              <div className="w-c200 h-20 rounded-2xl object-cover flex flex-col justify-center items-center bg-neutral-200 hover:bg-neutral-300 transition-colors duration-200 cursor-pointer relative">
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleFacadeUpload}
                  className="absolute inset-0 w-full h-full opacity-0 cursor-pointer z-10"
                  disabled={loadingFacadeUpload}
                />
                {loadingFacadeUpload ? (
                  <SmallSpinner />
                ) : (
                  <>
                    <Icon1 icon_name="image" fill="grey" size={24}></Icon1>
                    <div className="text-xs text-gray-500 mt-1">
                      Ajouter une photo
                    </div>
                  </>
                )}
              </div>
            )}
          </div>
          <div className="flex flex-row gap-2 mt-4">
            <TabGPT
              tabs={tabs}
              activeTab={activetab}
              setActiveTab={handleTabChange}
            ></TabGPT>
          </div>
          {activetab === "partners" && (
            <>
              <div className="flex flex-col xl:flex-row justify-between gap-4 mt-4">
                <SearchBarDocuments
                  placeholder="Rechercher un partenaire ..."
                  value={input_value}
                  orgData={orgData}
                  setSeachType={(type: any) => {}}
                  setValue={setInputValue}
                  options={(all_partners || []).map((partner) => ({
                    label: partner.name,
                    value: partner.id,
                  }))}
                  onAction={(e: any) => {
                    // Do nothing or show partner details
                  }}
                ></SearchBarDocuments>
              </div>
              <div className="flex flex-row h-full mt-4">
                {loadingPartners ? (
                  <SmallSpinner />
                ) : (
                  <MMName
                    label="Partenaires invités"
                    users={partners == null ? [] : partners}
                    removable={true}
                    className="flex-grow"
                    options={partner_options}
                    value={null}
                    loading={loadingPartners}
                    placeholder={"Entreprise"}
                    setValue={setPartnerValue}
                    onAction={handlenewPartner}
                    onDelete={onDeletePartner}
                    type="org"
                    title={"Partenaires invités"}
                    icon_name={"partner"}
                  ></MMName>
                )}
              </div>
            </>
          )}
          {activetab === "documents" && (
            <>
              <div className="flex flex-col xl:flex-row  justify-between gap-4 mt-4">
                <SearchBarDocuments
                  placeholder="Rechercher un document ..."
                  value={input_value}
                  orgData={orgData}
                  setSeachType={(type: any) => {}}
                  setValue={setInputValue}
                  options={documents.map((doc) => ({
                    label: doc?.file?.name,
                    value: doc?.id,
                  }))}
                  onAction={(e: any) => {
                    // open the document
                    let doc = documents.find((doc) => doc.id === e.value);
                    if (!doc) return;
                    if (doc?.file?.name.endsWith(".pdf")) {
                      setSelectedFile(doc?.file || null);
                      setPdfOpen(true);
                    } else {
                      window.open(doc?.file?.url, "_blank");
                    }
                  }}
                ></SearchBarDocuments>
                <PrimaryButton onClick={() => setDropOpen(true)}>
                  Ajouter un document
                  <Icon1 icon_name="plus" size={16} fill="white"></Icon1>
                </PrimaryButton>
              </div>
              <div className="flex flex-col  mt-4">
                <DocBlock
                  title="XML"
                  documents={documents}
                  type="xml"
                  handleLoadPdf={handleLoadPdf}
                  handleDeleteDocument={handleDeleteDocument}
                ></DocBlock>
                <DocBlock
                  title="Contrats d'assurance"
                  documents={documents}
                  type="contrat"
                  handleLoadPdf={handleLoadPdf}
                  handleDeleteDocument={handleDeleteDocument}
                ></DocBlock>
                <DocBlock
                  title="Contrats d'entretien"
                  documents={documents}
                  type="entretien"
                  handleLoadPdf={handleLoadPdf}
                  handleDeleteDocument={handleDeleteDocument}
                ></DocBlock>
                <DocBlock
                  title="Ouvrages exécutés"
                  documents={documents}
                  type="ouvrage"
                  handleLoadPdf={handleLoadPdf}
                  handleDeleteDocument={handleDeleteDocument}
                ></DocBlock>
                <DocBlock
                  title="Mes diagnostics"
                  documents={documents}
                  handleLoadPdf={handleLoadPdf}
                  handleDeleteDocument={handleDeleteDocument}
                  type="diagnostic"
                ></DocBlock>
                <DocBlock
                  title="Photos"
                  documents={documents}
                  handleLoadPdf={handleLoadPdf}
                  handleDeleteDocument={handleDeleteDocument}
                  type="photos"
                ></DocBlock>
                <DocBlock
                  title="Factures"
                  documents={documents}
                  handleLoadPdf={handleLoadPdf}
                  handleDeleteDocument={handleDeleteDocument}
                  type="factures"
                ></DocBlock>
                <DocBlock
                  title="Plans"
                  documents={documents}
                  handleLoadPdf={handleLoadPdf}
                  handleDeleteDocument={handleDeleteDocument}
                  type="plans"
                ></DocBlock>
              </div>
            </>
          )}
          {activetab === "tools" && (
            <>
              <div className="flex flex-col xl:flex-row  justify-between gap-4 mt-4">
                <SearchBarDocuments
                  orgData={orgData}
                  options={[]}
                  value={input_value}
                  setValue={setInputValue}
                  setSeachType={(type: any) => {}}
                  onAction={(e: any) => {}}
                  placeholder="Rechercher un équipement ..."
                ></SearchBarDocuments>
                <div className="relative">
                  <PrimaryButton
                    onClick={() => {
                      setEquipmentDropdownOpen(!equipmentDropdownOpen);
                    }}
                  >
                    Ajouter un équipement
                    <Icon1 icon_name="down" size={16} fill="white"></Icon1>
                  </PrimaryButton>

                  {equipmentDropdownOpen && (
                    <>
                      <div
                        className="fixed h-screen w-screen top-0 left-0 z-10 bg-shadow_10 "
                        onClick={() => setEquipmentDropdownOpen(false)}
                      ></div>
                      <div
                        onClick={(e) => e.stopPropagation()}
                        className="border absolute top-10 z-10 right-0 min-w-c200 text-h3 flex flex-col cursor-pointer h-fit shadow-lg text-black rounded-xl"
                      >
                        <div className="bg-wshadow_75 p-1 rounded-xl flex flex-col">
                          <div className="flex flex-row gap-2 items-center">
                            <div className="flex flex-col text-h3 w-fit">
                              <div
                                onClick={() => {
                                  setToolOpen(true);
                                  setEquipmentDropdownOpen(false);
                                }}
                                className="flex flex-row gap-4 w-fit transition-all duration-300 ease-in-out min-w-c250 bg-white rounded-lg py-3 px-4 hover:bg-neutral-100 cursor-pointer"
                              >
                                <Icon1 icon_name="plus" size={18}></Icon1>
                                <span className="min-w-fit">
                                  Ajouter un équipement
                                </span>
                              </div>
                              <div
                                onClick={handleExtractFromXml}
                                className="flex flex-row gap-4 w-fit transition-all duration-300 ease-in-out min-w-c250 bg-white rounded-lg py-3 px-4 hover:bg-neutral-100 cursor-pointer"
                              >
                                <Icon1 icon_name="upload" size={18}></Icon1>
                                <span className="min-w-fit">
                                  Extraire du Xml
                                </span>
                                {loadingXmlExtract && <SmallSpinner />}
                              </div>
                              <div
                                onClick={handleOpenBookshelfImport}
                                className="flex flex-row gap-4 w-fit transition-all duration-300 ease-in-out min-w-c250 bg-white rounded-lg py-3 px-4 hover:bg-neutral-100 cursor-pointer"
                              >
                                <Icon1 icon_name="import" size={18}></Icon1>
                                <span className="min-w-fit">
                                  Importer un équipement
                                </span>
                                {loadingBookshelfEquipments && <SmallSpinner />}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                </div>
              </div>
              <div className="flex flex-col gap-4 mt-4">
                {/* Group equipments by piece */}
                {(pieceOptions || []).map((pieceName) => (
                  <div
                    key={pieceName.value}
                    className="mb-2 bg-neutral-50 rounded-lg borde p-4"
                  >
                    <div className="flex r flex-row justify-between items-center gap-2 mb-2">
                      <div className="text-h3 font-semibold text-indigo-700">
                        {pieceName.value}
                      </div>

                      <SecondaryButton
                        onClick={() => handleRemovePiece(pieceName.value)}
                      >
                        Supprimer
                      </SecondaryButton>
                    </div>
                    <div className="flex flex-col gap-2">
                      {equipments
                        .filter((eq) => eq.piece === pieceName.value)
                        .sort((a, b) =>
                          (a.name ?? "").localeCompare(b.name ?? "")
                        )
                        .map((eq, index) => (
                          <div
                            key={eq.id || index}
                            onClick={() => {
                              setSelectedEquipment(eq);
                              setEquipmentModalOpen(true);
                            }}
                            className="flex flex-col gap-4 items-center cursor-pointer hover:shadow-md bg-white rounded-3xl p-4 shadow-sm  w-fit "
                          >
                            <EquipementImage equipment={eq}></EquipementImage>
                            <div className="flex flex-row gap-2">
                              <div className="text-h3 mr-4 font-medium">
                                {eq.name}
                              </div>
                              <div
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleRemoveEquipment(eq.id);
                                }}
                                className="flex flex-row gap-2"
                              >
                                <Icon1
                                  icon_name="delete"
                                  size={20}
                                  fill="grey"
                                  hover_color="red"
                                ></Icon1>
                              </div>
                            </div>
                          </div>
                        ))}
                      {equipments.filter((eq) => eq.piece === pieceName.value)
                        .length === 0 && (
                        <div className="text-gray-400 italic text-sm ml-2">
                          Aucun équipement pour cette pièce.
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
              {/* Equipment Modal */}
              <EquipmentModal
                equipmentId={selectedEquipment?.id}
                open={equipmentModalOpen}
                onClose={() => setEquipmentModalOpen(false)}
                onRefresh={handleFetchData}
                prefix={prefix}
                orgId={orgData?.id}
              />
            </>
          )}
        </div>
        <div className="flex flex-col">
          <div className="font-medium text-h2 text-black mt-10">
            Informations
          </div>
          <div className="flex flex-col gap-2 mt-6">
            <CodeInfoCell
              handleClickVariant={handleClickVariant as any}
              title="Code"
              data={carnetData.code}
              activated={carnetData.activated}
            />
            <ActivatedInfoCell
              title="Status"
              data={carnetData.activated ? "Activé" : "Non activé"}
            />
            <InfoCell
              title="Création"
              data={getLocalStringFromFlutter(carnetData.creation_date)}
            />
          </div>
          {carnetData.state === "pending_transfer" && (
            <div className="mt-6 bg-orange-100 rounded-lg p-4 flex flex-col gap-1 border-1 border-orange-200">
              <div className="text-h2 font-medium text-orange-400">
                Transfert en cours
              </div>{" "}
              <div className="text-h3  text-shadow_50">
                Le carnet est en cours de transfert vers un autre particulier
              </div>{" "}
              <div className="text-h2  text-shadow_25">
                Email : {carnetData.pending_invitation?.new_email}
              </div>{" "}
              <div className="text-h2  text-shadow_25">
                Téléphone : {carnetData.pending_invitation?.new_phone}
              </div>
            </div>
          )}
          <div className="flex flex-col gap-2 mt-6">
            <EditableInfoCell
              title="Nom"
              data={carnetData.name}
              onChangeData={(e) => handleChangeInfoCell("name", e.target.value)}
              handleSync={() => handleSyncInfoCell("name", carnetData.name)}
              orgData={orgData}
              carnetData={carnetData}
            />{" "}
            <EditableInfoCell
              title="Prénom"
              data={carnetData.first_name}
              onChangeData={(e) =>
                handleChangeInfoCell("first_name", e.target.value)
              }
              handleSync={() =>
                handleSyncInfoCell("first_name", carnetData.first_name)
              }
              orgData={orgData}
              carnetData={carnetData}
            />
            <EditableInfoCell
              title="Email"
              data={carnetData.email}
              onChangeData={(e) =>
                handleChangeInfoCell("email", e.target.value)
              }
              handleSync={() => handleSyncInfoCell("email", carnetData.email)}
              orgData={orgData}
              carnetData={carnetData}
            />
            <EditableInfoCell
              title="Téléphone"
              data={carnetData.phone}
              onChangeData={(e) =>
                handleChangeInfoCell("phone", e.target.value)
              }
              handleSync={() => handleSyncInfoCell("phone", carnetData.phone)}
              orgData={orgData}
              carnetData={carnetData}
              type="phone"
            />
            <EditableInfoCell
              title="Code postal"
              data={carnetData.postal}
              onChangeData={(e) =>
                handleChangeInfoCell("postal", e.target.value)
              }
              handleSync={() => handleSyncInfoCell("postal", carnetData.postal)}
              orgData={orgData}
              carnetData={carnetData}
            />
            <EditableInfoCell
              title="Ville"
              data={carnetData.city}
              onChangeData={(e) => handleChangeInfoCell("city", e.target.value)}
              handleSync={() => handleSyncInfoCell("city", carnetData.city)}
              orgData={orgData}
              carnetData={carnetData}
            />
            <EditableInfoCell
              title="Adresse"
              data={carnetData.address}
              onChangeData={(e) =>
                handleChangeInfoCell("address", e.target.value)
              }
              handleSync={() =>
                handleSyncInfoCell("address", carnetData.address)
              }
              orgData={orgData}
              carnetData={carnetData}
            />
          </div>
          <div className="font-medium text-h2 text-black mt-10">
            Constructeur
          </div>
          <div className="flex flex-col gap-2 mt-6">
            <EditableInfoCell
              title="Nom"
              data={carnetData.proclient_infos?.name}
              onChangeData={(e) =>
                handleChangeInfoCell("proclient_infos", {
                  ...carnetData.proclient_infos,
                  name: e.target.value,
                })
              }
              handleSync={() =>
                handleSyncInfoCell("proclient_infos", {
                  ...carnetData.proclient_infos,
                  name: carnetData.proclient_infos?.name,
                })
              }
              orgData={orgData}
              carnetData={carnetData}
            />
            <EditableInfoCell
              title="Adresse"
              data={carnetData.proclient_infos?.address}
              onChangeData={(e) =>
                handleChangeInfoCell("proclient_infos", {
                  ...carnetData.proclient_infos,
                  address: e.target.value,
                })
              }
              handleSync={() =>
                handleSyncInfoCell("proclient_infos", {
                  ...carnetData.proclient_infos,
                  address: carnetData.proclient_infos?.address,
                })
              }
              orgData={orgData}
              carnetData={carnetData}
            />
            <EditableInfoCell
              title="Code postal"
              data={carnetData.proclient_infos?.postal}
              onChangeData={(e) =>
                handleChangeInfoCell("proclient_infos", {
                  ...carnetData.proclient_infos,
                  postal: e.target.value,
                })
              }
              handleSync={() =>
                handleSyncInfoCell("proclient_infos", {
                  ...carnetData.proclient_infos,
                  postal: carnetData.proclient_infos?.postal,
                })
              }
              orgData={orgData}
              carnetData={carnetData}
            />
            <EditableInfoCell
              title="Ville"
              data={carnetData.proclient_infos?.city}
              onChangeData={(e) =>
                handleChangeInfoCell("proclient_infos", {
                  ...carnetData.proclient_infos,
                  city: e.target.value,
                })
              }
              handleSync={() =>
                handleSyncInfoCell("proclient_infos", {
                  ...carnetData.proclient_infos,
                  city: carnetData.proclient_infos?.city,
                })
              }
              orgData={orgData}
              carnetData={carnetData}
            />
            <EditableInfoCell
              title="Téléphone"
              data={carnetData.proclient_infos?.phone}
              onChangeData={(e) =>
                handleChangeInfoCell("proclient_infos", {
                  ...carnetData.proclient_infos,
                  phone: e.target.value,
                })
              }
              handleSync={() =>
                handleSyncInfoCell("proclient_infos", {
                  ...carnetData.proclient_infos,
                  phone: carnetData.proclient_infos?.phone,
                })
              }
              orgData={orgData}
              carnetData={carnetData}
            />
            <EditableInfoCell
              title="Email"
              data={carnetData.proclient_infos?.email}
              onChangeData={(e) =>
                handleChangeInfoCell("proclient_infos", {
                  ...carnetData.proclient_infos,
                  email: e.target.value,
                })
              }
              handleSync={() =>
                handleSyncInfoCell("proclient_infos", {
                  ...carnetData.proclient_infos,
                  email: carnetData.proclient_infos?.email,
                })
              }
              orgData={orgData}
              carnetData={carnetData}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

interface EditableInfoCellProps {
  title: string;
  data: any;
  onChangeData: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleSync: () => void;
  orgData: Org;
  carnetData: Carnet;
  type?: string; // Optional type for specific handling, e.g., phone
}

export const EditableInfoCell = ({
  title,
  data,
  onChangeData,
  handleSync,
  orgData,
  carnetData,
  type,
}: EditableInfoCellProps) => {
  const [editable, setEditable] = useState(false);

  const handleSet = () => {
    setEditable(false);
    handleSync();
    // Add additional logic if needed for "onEnter"
  };

  const onChange = (e: any) => {
    onChangeData(e);
  };

  return (
    <div className="cursor-pointer w-full">
      {!editable && (
        <div
          onClick={() => {
            orgData.id === carnetData.master_id && setEditable(!editable);
          }}
        >
          <div>
            <InfoCell
              title={title}
              data={data}
              editable={orgData.id === carnetData.master_id}
            />
          </div>
        </div>
      )}
      {editable && (
        <div>
          <Tippy
            content="Appuyez sur Entrée pour valider"
            className="custom-tooltip"
            delay={500}
          >
            <div>
              <TextField2
                transparent={true}
                value={data}
                onChange={onChange}
                label={title}
                onEnter={handleSet}
                type={type}
                autofocus={true}
              />
            </div>
          </Tippy>
        </div>
      )}
    </div>
  );
};

interface InfoCellProps {
  title: string;
  data: any;
  editable?: boolean;
}

export function InfoCell({ title, data, editable = false }: InfoCellProps) {
  return (
    <div className="flex flex-row items-center gap-1">
      <div className="text-h3 font-medium min-w-c100 w-c100 ">{title}</div>
      <div
        className={`text-h3 rounded-md py-1 border-slate-200 border-1 h-fit min-h-7 w-c250 px-2 mr-2  flex-grow bg-shadow_4  font-light text-pr ${
          editable ? "cursor-pointer  hover:border-blue-400 " : " "
        }`}
      >
        {data}
      </div>
    </div>
  );
}

interface CodeInfoCellProps {
  title: string;
  data: any;
  editable?: boolean;
  activated?: boolean;
  handleClickVariant?: (
    message: string,
    variant: "success" | "error" | "default" | "warning" | "info" | undefined
  ) => {};
}

export function CodeInfoCell({
  title,
  data,
  editable = false,
  activated = false,
  handleClickVariant = () => ({}),
}: CodeInfoCellProps) {
  const displayData = !activated && data ? "HL-******" : data;

  return (
    <div className="flex flex-row items-center gap-1">
      <div className="text-h3 min-w-c100 w-c100 text-primary  font-bold">
        {title}
      </div>
      <div
        className={`text-h3 rounded-md py-1 h-fit text-primary border-slate-200 border-1 min-h-7 w-full px-2 mr-2  flex-grow bg-shadow_4  font-bold text-pr ${
          editable ? "cursor-pointer  hover:border-blue-400 " : " "
        }`}
      >
        {displayData}
      </div>
      <div
        onClick={() => {
          if (activated) {
            navigator.clipboard.writeText(data);
            handleClickVariant("Code copié dans le presse-papiers", "success");
          } else {
            handleClickVariant(
              "Le code n'est pas encore disponible",
              "warning"
            );
          }
        }}
        className="cursor-pointer"
      >
        <Icon1
          icon_name="copy"
          size={20}
          fill="grey"
          hover_color="blue"
        ></Icon1>
      </div>
    </div>
  );
}

export function ActivatedInfoCell({
  title,
  data,
  editable = false,
}: CodeInfoCellProps) {
  return (
    <div className="flex flex-row items-center gap-1">
      <div className="text-h3 min-w-c100 w-c100 ">{title}</div>
      <div
        className={`
          ${
            data === "Activé"
              ? "text-green-500 bg-green-50"
              : "text-neutral-400 bg-neutral-200"
          }
          text-h3 flex flex-row justify-between rounded-md py-1 h-fit  border-slate-200 border-1 min-h-7 w-c250 px-2 mr-2  flex-grow  font-bold text-pr `}
      >
        {data}
        <Icon1 icon_name="done2" fill="#22c55e" size={16}></Icon1>
      </div>
    </div>
  );
}

interface DocBlockProps {
  title: string;
  documents?: any[];
  type?: string;
  handleLoadPdf: (doc: any) => void;
  handleDeleteDocument?: (doc: any) => void;
}

export const DocBlock = ({
  title,
  documents = [],
  type = "",
  handleLoadPdf,
  handleDeleteDocument,
}: DocBlockProps) => {
  return (
    <Collapsible
      title={
        title + " (" + documents.filter((doc) => doc.type === type).length + ")"
      }
    >
      <div className="flex flex-col  ">
        {documents
          .filter((doc: any) => doc.type === type)
          .sort((a: any, b: any) => a.file.name.localeCompare(b.file.name))
          .map((doc: any, index) => (
            <div
              key={index}
              className="flex flex-row gap-2 items-center cursor-pointer bg-white rounded-lg w-fit px-3 py-2 hover:bg-neutral-100"
            >
              <Icon1 icon_name="file" size={20} fill="black"></Icon1>
              <div
                className="text-h3 font-medium hover:underline"
                onClick={() => {
                  handleLoadPdf(doc);
                }}
              >
                {doc.file.name}
              </div>
              <Tippy
                content="Supprimer le document"
                className="custom-tooltip"
                delay={500}
              >
                <div
                  onClick={(e) => {
                    e.stopPropagation();
                    handleDeleteDocument?.(doc);
                  }}
                >
                  <Icon1
                    icon_name="delete"
                    size={16}
                    fill="grey"
                    hover_color="red"
                  />
                </div>
              </Tippy>
            </div>
          ))}
      </div>
    </Collapsible>
  );
};
